import utils from '../../../../utils/utils.js';

const actions = {
  // ============================================================================
  // SNIFFDECK PATTERN: Clean MT actions without try-catch
  // ============================================================================

  // Group users loading with silent mode - Sniffdeck pattern
  async fetchGroupUsers({ commit }) {
    const response = await utils.utility.fetch(
      'api/Dashboard/GetWorkspaceGroupsUsers', 
      'GET', null, null, true // Silent mode
    );
    
    commit('setGroupUsers', response.data || response);
  },
  async fetchAnswerRateAnalyticData({ commit }, payload) {
    const userParams = payload.Users.split(',').map(userId => `Users=${userId}`).join('&');
    const url = `api/Dashboard/GetMtAnswerRateAnalyticdata?StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&${userParams}`;
    
    const response = await utils.utility.fetch(url, 'GET', null, null);
    
    commit('setAnswerRateAnalyticData', response.data || response);
    return { success: true, data: response.data || response };
  },

  // MT Operational Efficiency - Sniffdeck pattern
  async fetchMtOperationalEfficiencyAnalyticData({ commit }, payload) {    
    const userParams = payload.Users.split(',').map(userId => `Users=${userId}`).join('&');
    const url = `api/Dashboard/GetMtOperationalEfficiencyAnalyticData?StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&${userParams}`;
    
    const response = await utils.utility.fetch(url, 'GET', null, null);
    
    commit('setMtOperationalEfficiencyAnalyticData', response.data || response);
    return { success: true, data: response.data || response };
  },

  // MT Daily Operational Efficiency - Clean approach
  async fetchMtDailyOperationalEfficiencyAnalyticData({ commit }, payload) {
    const userParams = payload.Users.split(',').map(userId => `Users=${userId}`).join('&');
    const url = `api/Dashboard/GetMtDailyOperationalEfficiencyAnalyticData?StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&${userParams}`;
    
    const response = await utils.utility.fetch(url, 'GET', null, null);
    
    const data = response.data || response;
    commit('setWidgetData', { widgetId: 'daily-operational-efficiency', data });
    return { success: true, data };
  },

  // MT Answer Total Rate - with By parameter support
  async fetchMtAnswerTotalRateAnalyticData({ commit }, payload) {
    const userParams = payload.Users.split(',').map(userId => `Users=${userId}`).join('&');
    let url = `api/Dashboard/GetMtAnswerTotalRateAnalyticData?StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&${userParams}`;
    
    if (payload.By) {
      url += `&By=${payload.By}`;
    }
    
    const response = await utils.utility.fetch(url, 'GET', null, null);
    
    commit('setMtAnswerTotalRateAnalyticData', response.data || response);
    return { success: true, data: response.data || response };
  },

  // MT Touching Rate - Sniffdeck pattern
  async fetchMtTouchingRateAnalyticData({ commit }, payload) {
    const userParams = payload.Users.split(',').map(userId => `Users=${userId}`).join('&');
    const url = `api/Dashboard/GetMtTouchingRateAnalyticData?StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&${userParams}`;
    
    const response = await utils.utility.fetch(url, 'GET', null, null);
    
    commit('setMtTouchingRateAnalyticData', response.data || response);
    return { success: true, data: response.data || response };
  },

  // Use shared cross-module account loading
  async loadAccounts({ dispatch }) {
    await dispatch('shared/loadWorkspaceAccounts', null, { root: true });
  },

  // Generic widget data fetcher - routes to specific MT actions
  async fetchWidgetData({ dispatch, commit }, { widgetId, endpoint, payload }) {
    let response;
    
    // Route to specific MT action based on endpoint
    const ep = (endpoint || '').toLowerCase();
    if (ep.includes('getmtanswerrateanalyticdata')) {
      response = await dispatch('fetchAnswerRateAnalyticData', payload);
    } else if (ep.includes('getmtanswertotalrateanalyticdata')) {
      response = await dispatch('fetchMtAnswerTotalRateAnalyticData', payload);
    } else if (ep.includes('getmtoperationalefficiencyanalyticdata')) {
      response = await dispatch('fetchMtOperationalEfficiencyAnalyticData', payload);
    } else if (ep.includes('getmtdailyoperationalefficiencyanalyticdata')) {
      response = await dispatch('fetchMtDailyOperationalEfficiencyAnalyticData', payload);
    } else if (ep.includes('getmttouchingrateanalyticdata')) {
      response = await dispatch('fetchMtTouchingRateAnalyticData', payload);
    } else {
      return { success: false, error: 'Unknown endpoint' };
    }
    
    // Widget-specific data commit
    if (response.success && response.data) {
      commit('setWidgetData', { widgetId, data: response.data });
    }
    
    return response;
  }
};

export default actions;
